export const ADMIN_AUTH_KEY = "MIX_MASTER_AUTH_DATA";
export const TOAST_ID = "GLOBAL_TOAST_ID";
export const BANNER_IMAGE =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/w_2200/v1773315880/gpa4ipzradhyydke0sum.png";
export const ABOUT_IMAGE =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1773479656/bck7tump2bnbmc2a4cea.png";
export const WHO_WE_ARE_IMAGE =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1773484835/onsdkysi4euidhatc5uz.png";
export const PROJECT_IMAGE_1 =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1773731653/huqjaqkp3ebatkn30wve.png";
export const PROJECT_IMAGE_2 =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1773732221/u2z1cdgvxkiae0yfxmam.png";
export const OUR_SERVICE_IMAGE =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1777357714/hnnnizkzl3gpg6txfrgw.webp";
export const FAQ_IMAGE =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1773732509/i0mhqjopnlqw9u00vzsq.png";
export const HOW_IT_WORKS_IMAGE =
  "https://res.cloudinary.com/dqxlte6wf/image/upload/v1773732776/zlhmxsvgbylueck4itz1.png";
